import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation('common');
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <span className="footer-left">{t('copyright', { year: currentYear })}</span>
      <span className="footer-right">
        <a href="mailto:tpp-support@tui.com?Subject=Tpp Support" target="_top">
          {t('support')}
        </a>
        <span className="footer-separator"> | </span>
        <a href="https://confluence.tuigroup.com/display/ITDS/Tpp+3.0" target="_blank" rel="noreferrer">
          {t('wiki')}
        </a>
      </span>
    </footer>
  );
};

export default Footer;
